var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-root" },
    [
      _c("Search", {
        staticClass: "filter",
        attrs: { placeholder: _vm.$t("tradeAssets.search") },
        model: {
          value: _vm.filterKey,
          callback: function($$v) {
            _vm.filterKey = $$v
          },
          expression: "filterKey"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter op __pointer", on: { click: _vm.addToken } },
        [
          _c("span", { staticClass: "op__input add_token" }),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.$t("tokenCard.addToken.title")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter op" },
        [
          _c("Checkbox", {
            staticClass: "op__input",
            attrs: { value: _vm.hideZero },
            on: { input: _vm.hideZeroAssets }
          }),
          _vm._v("\n        " + _vm._s(_vm.$t("tradeAssets.zero")) + "\n    ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter op click-able more __pointer",
          on: { click: _vm.more }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("tokenCard.moreRecords")) +
              "\n        "
          ),
          _c("span", { staticClass: "more_records" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }